import { activityRequest } from "./request";

export const GET = async (endPoint: string, token: string) => {
  const response = await activityRequest.get(endPoint, {
    headers: {
      authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return { response };
};

export const POST = async (
  endPoint: string,
  body: any,
  token: string,
  ContentType?: "string"
) => {
  const response = await activityRequest.post(endPoint, body, {
    headers: {
      authorization: `Bearer ${token}`,
      "Content-Type": ContentType ? ContentType : "application/json",
    },
  });

  return { response };
};
